import { gql } from '@apollo/client'
import { IQueryBasicData, ID } from '../IQueryData'

export interface IOrderVariantDay {
  day: string
  pool_parking_id: ID
}

export interface IOrderCompanyParkingTicketForUserVars {
  login: string
  days: string[]
  variant: IOrderVariantDay[]
  notify: boolean
}

export interface IOrderCompanyParkingTicketForUserData {
  orderCompanyParkingTicketForUser: IQueryBasicData
}

export const ORDER_COMPANY_PARKING_TICKET_FOR_USER = gql`
  mutation orderCompanyParkingTicketForUser(
    $login: String!
    $days: [DateTime!]!
    $variant: [OrderVariantDayInput!]
    $notify: Boolean
  ) {
    orderCompanyParkingTicketForUser(
      login: $login
      days: $days
      variant: $variant
      notify: $notify
    ) {
      status
      code
      error
      message
    }
  }
`
